module.exports = __webpack_public_path__ + "static/img/b04.4398292.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b04.jpg
// module id = l/vN
// module chunks = 1